import { StyleSheet } from 'react-native';

import CardDetailImage from './CardDetailImage';
import Colors from '../../constants/Colors';
import useColorScheme from '../../hooks/useColorScheme';
import { CdnImageName } from '../../utils/common';
import { Icon } from '../Icon';
import { TextBody } from '../StyledText';
import { StyleProps, View } from '../Themed';

type GiftCardDetailProps = StyleProps & {
  title: string;
  imageIndex: number;
  accent?: boolean;
};

export default function GiftCardDetail({
  title,
  accent,
  style,
  imageIndex,
}: GiftCardDetailProps) {
  const theme = useColorScheme();
  const backgroundColor = accent ? 'accentSecondary' : 'background';
  const tintColor = accent ? 'background' : 'accentSecondary';
  return (
    <View
      style={[
        {
          shadowRadius: 8,
          shadowOpacity: 0.8,
          shadowOffset: {
            width: 0,
            height: 4,
          },
          shadowColor: Colors[theme].shadow,
        },
        style,
      ]}
      lightColor={Colors.light[backgroundColor]}
      darkColor={Colors.dark[backgroundColor]}
    >
      <CardDetailImage
        style={styles.image}
        source={`gift${imageIndex}.webp` as CdnImageName}
      />
      <Icon name="heart" color={Colors[theme][tintColor]} style={styles.icon} />
      <TextBody>{title}</TextBody>
    </View>
  );
}

const styles = StyleSheet.create({
  image: {
    width: 156,
    height: 156,
  },
  icon: {
    marginTop: 10,
    marginBottom: 10,
  },
});
